import { render, staticRenderFns } from "./AwsS3.vue?vue&type=template&id=1048f61c&"
import script from "./AwsS3.vue?vue&type=script&lang=ts&"
export * from "./AwsS3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports